<template>
  <form :id="'frm-'+id"
        class="px-3"
        method="post"
        onsubmit="return false">
    <div :id="id"
         :aria-labelledby="id+'-title'"
         :data-id="name"
         aria-hidden="true"
         class="modal fade"
         data-backdrop="static"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header mb-2">
            <h5 :id="id+'-title'" class="modal-title">{{
                completeStatus ? 'Compromiso cumplido' : 'Compromiso vencido'
                                                      }}</h5>
          </div>
          <div class="modal-body">
            <div class="container">
              <div :class="{ 'd-none': !completeStatus }">
                <file-list-input :update-files-input-value="updateFilesInputValue"
                                 :selected-files="selectedFiles"></file-list-input>
                <div class="form-group">
                  <label class="font-weight-normal"
                         for="comments">Comentarios:</label>
                  <textarea id="comments"
                            v-model="comments"
                            class="form-control"
                            name="comments"
                            rows="5"></textarea>
                </div>
              </div>
              <div :class="{ 'd-none': completeStatus }">
                <div class="form-group">
                  <label class="font-weight-normal"
                         for="justification">Justificación:</label>
                  <textarea id="justification"
                            v-model="justification"
                            class="form-control"
                            name="justification"
                            rows="5"></textarea>
                </div>
                <div class="form-group">
                  <h4 class="list-group-item-title font-weight-bold">
                    ¿Recalendarizar compromiso?:
                  </h4>
                  <div class="form-check form-check-inline">
                    <input id="schedule_true"
                           v-model="schedule"
                           :value="true"
                           class="form-check-input"
                           name="schedule"
                           type="radio">
                    <label class="form-check-label font-weight-normal" for="schedule_true">Sí</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input id="schedule_false"
                           v-model="schedule"
                           :value="false"
                           class="form-check-input"
                           name="schedule"
                           type="radio">
                    <label class="form-check-label font-weight-normal" for="schedule_false">No</label>
                  </div>
                </div>
                <div :class="{ 'd-none': !schedule }" class="form-group">
                  <label class="font-weight-normal"
                         for="new_date">Nueva fecha de cumplimiento:</label>
                  <input id="new_date"
                         v-model="new_date"
                         class="form-control"
                         name="new_date"
                         placeholder="DD/MM/AAAA"
                         type="date">
                </div>
              </div>
            </div>
          </div>
          
          <div class="modal-footer flex px-2 shadow-none modal-body-scrolled">
            <button :disabled="sendingForm"
                    class="btn btn-primary mr-2"
                    type="submit">
              <template v-if="!sendingForm">{{overdueCommitment ? 'Editar' : 'Guardar'}}</template>
              <span v-if="sendingForm"
                    class="spinner-border text-yellow-500 spinner-border-sm"
                    role="status">
                <span class="sr-only">{{overdueCommitment ? 'Actualizando...' : 'Guardando...'}}</span>
              </span>
            </button>
            <button class="btn btn-secondary"
                    data-dismiss="modal"
                    type="button"
                    @click="clearForm(true)">Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import { AlertManager } from '../utils/AlertManager'
  import { mapActions, mapGetters } from 'vuex'
  import FileListInput from '../ui/FileListInput'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import 'jquery-validation'
  
  export default {
    name: 'FinancingCommitmentStatusModal',
    components: {
      FileListInput,
    },
    props: {
      id: {
        default: 'financing-commitments-status-modal',
      },
      name: {
        default: 'financing-commitments-status-modal',
      },
      completeStatus: {
        default: true,
      },
      financingCommitmentId: {
        default: null,
      },
      type: {
        default: null,
      },
      selectedRadioData: {
        default: null,
      },
      protocol: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        sendingForm: false,
        comments: '',
        justification: '',
        schedule: '',
        new_date: '',
        selectedFiles: [],
        overdueCommitment: null,
      }
    },
    methods: {
      ...mapActions({
        completeFinancinCommitment: 'protocols/completeFinancinCommitment',
        updateCompletedFinancinCommitment: 'protocols/updateCompletedFinancinCommitment',
        rescheduleFinancinCommitment: 'protocols/rescheduleFinancinCommitment',
        updateRescheduledFinancinCommitment: 'protocols/updateRescheduledFinancinCommitment',
        getFinancingCommitments: 'protocols/getFinancingCommitments',
        completeFinancingExtensionCommitment: 'protocols/completeFinancingExtensionCommitment',
        updateCompletedFinancingExtensionCommitment: 'protocols/updateCompletedFinancingExtensionCommitment',
        rescheduleFinancingExtensionCommitment: 'protocols/rescheduleFinancingExtensionCommitment',
        updateRescheduledFinancingExtensionCommitment: 'protocols/updateRescheduledFinancingExtensionCommitment',
      }),
      
      clearForm(canceling = false) {
        if(this.completeStatus) {
          //this.$refs.voucher.value = null
        }
        
        this.comments = ''
        this.justification = ''
        this.schedule = ''
        this.new_date = ''
        this.selectedFiles = []
        this.overdueCommitment = null

        if (canceling) {
          $('input[data-commitment-id="' + this.selectedRadioData +'"]').prop('checked', false)
        }
      },
      
      async submitForm() {
        if (this.completeStatus) {
          if (this.overdueCommitment) {
            await this.updateCompletedCommitment()
          } else {
            await this.completeCommitment()
          }
        }
        else {
          if (this.overdueCommitment) {
            await this.updateRescheduledCommitment()
          } else {
            await this.rescheduleCommitment()
          }
        }
      },
      
      async completeCommitment() {
        this.sendingForm = true
        
        const formData = new FormData()
        formData.append('commitment', this.financingCommitmentId)
        formData.append('comments', this.comments)

        this.selectedFiles.forEach(file => {
          formData.append('voucher[]', file.file)
        })
        
        const response = this.type === 'protocol'
          ? await this.completeFinancinCommitment(formData)
          : await this.completeFinancingExtensionCommitment(formData)
        
        const { error, status, message } = response.data.data
        
        if(status === 'success') {
          AlertManager.success(message)
        }
        else {
          AlertManager.error(error)
        }
        
        await this.getFinancingCommitments(this.protocol)
        
        this.sendingForm = false
        this.clearForm()
        $('#' + this.id).modal('hide')
      },
      
      async rescheduleCommitment() {
        this.sendingForm = true

        const data = {
          commitment: this.financingCommitmentId,
          justification: this.justification,
          schedule: this.schedule,
          new_date: this.new_date,
        }
        
        const response = this.type === 'protocol'
          ? await this.rescheduleFinancinCommitment(data)
          : await this.rescheduleFinancingExtensionCommitment(data)
        
        const { error, status, message } = response.data.data
        
        if(status === 'success') {
          AlertManager.success(message)
        }
        else {
          AlertManager.error(error)
        }
        
        await this.getFinancingCommitments(this.protocol)
        
        this.sendingForm = false
        this.clearForm()
        $('#' + this.id).modal('hide')
        console.log('cerrando modal')
      },

      async updateCompletedCommitment () {
        this.sendingForm = true

        const formData = new FormData()
        formData.append('updating', true)
        formData.append('commitment', this.financingCommitmentId)
        formData.append('comments', this.comments)

        this.selectedFiles.forEach(file => {
          if (file.file) {
            formData.append('voucher[]', file.file)
          } else {
            formData.append('keep_vouchers[]', file.file_id)
          }
        })
        
        const response = this.type === 'protocol'
          ? await this.updateCompletedFinancinCommitment(formData)
          : await this.updateCompletedFinancingExtensionCommitment(formData)
        
        const { error, status, message } = response.data.data
        
        if(status === 'success') {
          AlertManager.success(message)
        }
        else {
          AlertManager.error(error)
        }
        
        await this.getFinancingCommitments(this.protocol)
        
        this.sendingForm = false
        this.clearForm()
        $('#' + this.id).modal('hide')
      },
      
      async updateRescheduledCommitment () {
        this.sendingForm = true

        const data = {
          commitment: this.financingCommitmentId,
          overdueFinancingCommitment: this.overdueCommitment.hasOwnProperty('overdue_commitment_id') && this.overdueCommitment.overdue_commitment_id !== null ?
            this.overdueCommitment.overdue_commitment_id : this.overdueCommitment.id,
          justification: this.justification,
          schedule: this.schedule,
          new_date: this.new_date,
        }
        
        const response = this.type === 'protocol'
          ? await this.updateRescheduledFinancinCommitment(data)
          : await this.updateRescheduledFinancingExtensionCommitment(data)
        
        const { error, status, message } = response.data.data
        
        if(status === 'success') {
          AlertManager.success(message)
        }
        else {
          AlertManager.error(error)
        }
        
        await this.getFinancingCommitments(this.protocol)
        
        this.sendingForm = false
        this.clearForm()
        $('#' + this.id).modal('hide')
      },

      updateFilesInputValue(files) {
        this.selectedFiles = files
      },

      showModal (overdueCommitment = null) {
        if(overdueCommitment) {
          this.overdueCommitment = overdueCommitment
          this.comments = overdueCommitment.comments
          this.justification = overdueCommitment.justification
          this.schedule = overdueCommitment.new_date ? true : false
          this.new_date = overdueCommitment.new_date
          
          if (overdueCommitment.vouchers) {
            overdueCommitment.vouchers.forEach(file => {
              const { file_id, file_name } = file

              this.selectedFiles.push({
                id: Math.guid(),
                file_id: file_id,
                name: file_name,
              })
            })
          }
        }

        $('#' + this.id).modal('show')
      }
    },
    computed: {
      ...mapGetters({
        funders: 'protocols/funders',
      }),
    },
    mounted() {
      const vm = this

      /**
       * Init flatpickr for newDate input
       */
      this.$newDate = $('#new_date').flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
         minDate: new Date(),
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        $('#frm-' + vm.id).validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            if(element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            voucher: {
              required: function(element) {
                return vm.completeStatus;
              },
            },
            comments: {
              required: function(element) {
                return vm.completeStatus;
              },
            },
            justification: {
              required: function(element) {
                return !vm.completeStatus;
              },
            },
            schedule: {
              required: function(element) {
                return !vm.completeStatus;
              },
            },
            new_date: {
              required: function(element) {
                return !!(!vm.completeStatus && vm.schedule);
              },
            },
          },
          messages: {
            voucher: {
              required: 'Este campo es requerido.',
            },
            comments: {
              required: 'Este campo es requerido.',
            },
            justification: {
              required: 'Este campo es requerido.',
            },
            schedule: {
              required: 'Este campo es requerido.',
            },
            new_date: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler(form) {
            let validator = $('#frm-' + vm.id).validate()
            let errors 	  = { 'upload-file': 'Es necesario anexar por lo menos un archivo' }

            if (vm.completeStatus  && vm.selectedFiles.length < 1) {
              validator.showErrors(errors)
            } else {
              vm.submitForm()
            }
          },
        })
      })
    },
  }
</script>
